import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const courses = [
  {
    id: 1,
    name: "SolidWorks API",
    description: "Master SolidWorks API development using VB.NET and C# for enterprise plugin development and automation."
  },
  {
    id: 2,
    name: "NXOpen Development",
    description: "Advanced NXOpen programming for design automation, CAM integration, and manufacturing solutions."
  },
  {
    id: 3,
    name: "Eyeshot 3D Viewer",
    description: "Build powerful 3D CAD viewers and cloud-based visualization applications with devDept Eyeshot."
  },
  {
    id: 4,
    name: "AutoCAD .NET",
    description: "Professional AutoCAD customization using .NET API and LISP scripting for advanced automation."
  },
  {
    id: 5,
    name: "SolidWorks Premium",
    description: "Comprehensive 3D CAD design training for mechanical engineering and product development."
  },
  {
    id: 6,
    name: "NX CAD Advanced",
    description: "Advanced CAD/CAM/CAE solutions for complex product design and manufacturing optimization."
  },
  {
    id: 7,
    name: "CAD Automation",
    description: "Automate repetitive design tasks with scripting, macros, and custom tools across multiple platforms."
  },
  {
    id: 8,
    name: "Inventor Customization",
    description: "Inventor API programming and plugin development for design automation and workflow optimization."
  }
];

const CoursesSection = () => {
  return (
    <section 
      id="courses" 
      data-testid="courses-section"
      className="py-20 lg:py-28 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            data-testid="courses-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Popular Courses
          </h2>
          <p className="mt-4 text-lg text-[#0F172A]/60 max-w-2xl mx-auto">
            Industry-relevant programs designed by experts to boost your career
          </p>
        </div>

        {/* Courses Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {courses.map((course) => (
            <div
              key={course.id}
              data-testid={`course-card-${course.id}`}
              className="course-card bg-white border border-slate-200 rounded-2xl overflow-hidden hover:border-[#06B6D4]/30"
            >
              {/* Course Image Header */}
              <div className="h-32 overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/716661/pexels-photo-716661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt={`${course.name} blueprint`}
                  className="w-full h-full object-cover grayscale opacity-80 mix-blend-multiply"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 
                  className="text-xl font-semibold text-[#0F172A] mb-2"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {course.name}
                </h3>
                <p className="text-[#0F172A]/60 text-sm leading-relaxed mb-4">
                  {course.description}
                </p>
                <Link to={`/courses/${course.id}`}>
                  <Button
                    data-testid={`course-learn-more-${course.id}`}
                    variant="ghost"
                    className="p-0 h-auto text-[#2563EB] hover:text-[#1D4ED8] hover:bg-transparent font-medium group"
                  >
                    Learn More 
                    <ArrowRight className="ml-1 w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesSection;
